var React = require('react');

function IconLoading (props) {
    return React.createElement("svg",props,React.createElement("circle",{"cx":"50","cy":"50","r":"25","fill":"none","stroke":"#6471B4","strokeDasharray":"117.81 41.27","strokeWidth":"8","transform":"rotate(180 50 50)"},React.createElement("animateTransform",{"attributeName":"transform","begin":"0s","calcMode":"linear","dur":"1s","keyTimes":"0;1","repeatCount":"indefinite","type":"rotate","values":"0 50 50;360 50 50"})));
}

IconLoading.displayName = "IconLoading";

IconLoading.defaultProps = {"style":{"background":"0 0"},"preserveAspectRatio":"xMidYMid","viewBox":"0 0 100 100"};

module.exports = IconLoading;

IconLoading.default = IconLoading;
